import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20artistic%20illustration%20with%20soft%20warm%20gradients%2C%20abstract%20flowing%20ink%20and%20watercolor%20textures%20in%20coral%20pink%20and%20cream%20tones%2C%20dreamy%20ethereal%20atmosphere%2C%20delicate%20floating%20particles%2C%20minimal%20elegant%20composition%2C%20Korean%20aesthetic%20art%20style%2C%20no%20text&width=1600&height=900&seq=hero-bg-hanman&orientation=landscape"
          alt="韩漫画网 - 好看的韩国漫画在线免费阅读"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
          好看的韩国漫画
        </h1>
        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          韩漫画网精选高清韩国漫画，提供<strong>韩漫在线免费阅读</strong>服务。涵盖恋爱甜宠、奇幻冒险、动作热血等多种类型，
          <strong>高清韩漫大全</strong>画质清晰，带来视觉上的极致享受。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/love"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="border border-white/40 text-white hover:bg-white/10 px-8 py-3 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}